legalTitles = {
    init: function () {
        var $titles = $(".section-legal h2, .shopify-policy__body h2, .shopify-policy__body h3");

        if ($titles.length > 0) {
            var index = 1;

            $titles.each(function () {
                var $h2 = $(this);
                var num = ("0" + index).slice(-2);
                var originalText = $h2.text();
                $h2.html('<span class="num">' + num + '</span> ' + originalText);
                index++;
            });
        }
    }
};

$(document).ready(function () {
    legalTitles.init();
});
